import React, { useState } from "react";
import { NewTab, PageHeader, PageTab, PageTitle } from "../../../components";
import MyPendingTimesheets from "./Timesheet/MyPendingTimesheets";
import SubmitTimesheet from "./Timesheet/SubmitTimesheet";
import TimesheetDashboard from "./Timesheet/TimesheetDashboard";
import MyTimesheet from "./Timesheet/MyTimesheet";
import { useDispatch } from "react-redux";
import { usePagination } from "../../../hooks";

const Timesheet = () => {
  const dispatch = useDispatch();
  const [activeSubTab, setActiveSubTab] = useState(null);
  const [activeMainTabIndex, setActiveMainTabIndex] = useState(0);

  const handleBack = () => {
    setActiveSubTab(null);
  };

  const TimesheetMenus = [
    {
      title: "Timesheet Dashboard",
      // page: <TimesheetDashboard />,
      page:
        activeSubTab === "submit" ? (
          <SubmitTimesheet handleBack={handleBack} />
        ) : (
          <TimesheetDashboard />
        ),
      type: "main",
      subTabs:
        activeSubTab === "submit"
          ? []
          : [
              {
                title: "Submit Timesheet",
                icon: "add",
                action: () => setActiveSubTab("submit"),
              },
              {
                title: "Timesheet Settings",
                link: "/timesheet/timesheet-settings",
                type: "sub",
                icon: "settings",
              },
            ],
    },
    {
      title: "My Timesheet",
      // page: <MyTimesheet />,
      page:
        activeSubTab === "submit" ? (
          <SubmitTimesheet handleBack={handleBack} />
        ) : (
          <MyTimesheet />
        ),
      type: "main",
      subTabs:
        activeSubTab === "submit"
          ? []
          : [
              {
                title: "Submit Timesheet",
                icon: "add",
                action: () => setActiveSubTab("submit"),
              },
              {
                title: "Timesheet Settings",
                link: "/timesheet/timesheet-settings",
                type: "sub",
                icon: "settings",
              },
            ],
    },
    {
      title: "My Pending Timesheets",
      page:
        activeSubTab === "submit" ? (
          <SubmitTimesheet handleBack={handleBack} />
        ) : (
          <MyPendingTimesheets />
        ),
      type: "main",
      subTabs:
        activeSubTab === "submit"
          ? []
          : [
              {
                title: "Submit Timesheet",
                icon: "add",
                action: () => setActiveSubTab("submit"),
              },
              {
                title: "Timesheet Settings",
                link: "/timesheet/timesheet-settings",
                type: "sub",
                icon: "settings",
              },
            ],
    },

    {
      title: "Timesheet Settings",
      link: "/timesheet/timesheet-settings",
      type: "sub",
      icon: "settings",
    },
  ];

  const handleTabChange = (index) => {
    setActiveMainTabIndex(index);
    setActiveSubTab(null);
  };

  return (
    <>
      <PageHeader
        Section={
          <div className="flex my-3">
            <PageTitle title={"Timesheet Management"} tag="h5" />
          </div>
        }
      />
      <NewTab
        tabs={TimesheetMenus}
        color="black"
        variant="outlined"
        onTabChange={handleTabChange}
        mode="url"
        tabId="timesheet"
      />
    </>
  );
};

export default Timesheet;
